import React from 'react';
import { Col, FormGroup, Label, Input, Row } from 'reactstrap';
import { H5, Image } from 'AbstractElements';
import { useNavigate } from 'react-router-dom';
import { useSelector, useDispatch } from 'react-redux';
import PostCommon from 'Component/Common/Form/Post';
import DropzoneCommon from 'Component/Common/Upload/Dropzone';
import { submitDoctor } from 'Services/Features/Doctor/Utils/doctorUtils';
import { setFormData, resetFormData } from 'Services/Features/Doctor/doctorSlice';
import CustomLoader from 'Component/Common/CustomLoader';

const DoctorForm = ({ label, setRefetch }) => {
    const dispatch = useDispatch();
    const history = useNavigate();
    const data = useSelector(state => state.doctor.currentDoctor)
    console.log (data, 'data');
    const startUpload = useSelector(state => state.doctor.loading);

    const handleSuccess = () => {
        dispatch(resetFormData());
        history(`${process.env.PUBLIC_URL}/doctors`);
    };

    const handleSubmit = (e) => {
        e.preventDefault();
        console.log(data, 'data');
        dispatch(submitDoctor({ ...data, successCallback: handleSuccess }))
    };

    const handleDiscard = (e) => {
        e.preventDefault();
        dispatch(resetFormData());
        history(`${process.env.PUBLIC_URL}/doctors`);
    };
    const handleChanges = (e) => {
        const { name, value } = e.target;
        dispatch(setFormData({ [name]: value }));
    }

    const handleChangePhoto = ({ meta, file }, status) => {
        if (status === 'done') {
            dispatch(setFormData({ 'profile_picture': file }));
        } else if (status === 'removed') {
            dispatch(setFormData({ 'profile_picture': null }));
        }
    };


    return (
        <PostCommon title={label} handleSubmit={handleSubmit} handleDiscard={handleDiscard} >
            {startUpload && (
                <CustomLoader />
            )}
            <div>
                <Row className="mb-3">
                    <Col sm={6}>
                        <FormGroup className='mb-3'>
                            <Label for="validationName" style={{ fontWeight: 'bold' }}>Nama :</Label>
                            <Input
                                className="form-control"
                                id="validationName"
                                type="text"
                                name="name"
                                placeholder="Masukkan nama dokter..."
                                required=""
                                value={data.name}
                                onChange={handleChanges}
                            />
                        </FormGroup>
                        <FormGroup className='mb-3'>
                            <Label for="validationDescription" style={{ fontWeight: 'bold' }}>Deskripsi :</Label>
                            <Input
                                className="form-control"
                                id="validationDescription"
                                type="textarea"
                                name="description"
                                placeholder="Masukkan deskripsi dokter..."
                                value={data.description}
                                onChange={handleChanges}
                            />
                        </FormGroup>
                    </Col>

                    {data.profile_pictureLink ? (
                        <>
                            <Col sm="6">
                            <Row className="mb-3">
                                <Col sm="3" className="mb-3">
                                    <H5>Preview Foto</H5>
                                    <Image
                                        attrImage={{
                                            className: 'img-fluid w-100',
                                            src: data.profile_pictureLink,
                                            alt: `${data.name}`,
                                            style: {
                                                height: 'auto',
                                                width: '100%',
                                                maxWidth: '150px',
                                                objectFit: 'contain',
                                                borderRadius: '8px'
                                            }
                                        }}
                                    />
                                </Col>
                                <Col sm="9">
                                    <DropzoneCommon
                                        label={'Foto Dokter'}
                                        inputContent={<><i className="fa fa-upload"></i> Update Foto Dokter</>}
                                        handleChangeStatus={handleChangePhoto}
                                        accept="image/*"
                                        multiple={false}
                                        maxFiles={1}
                                    />
                                </Col>
                            </Row>
                            </Col>
                        </>
                    ) : (
                        <Col sm="6">
                            <DropzoneCommon
                                label={'Foto Dokter'}
                                inputContent={<><i className="fa fa-upload"></i> Upload Foto Dokter</>}
                                handleChangeStatus={handleChangePhoto}
                                accept="image/*"
                                multiple={false}
                                maxFiles={1}
                            />
                        </Col>
                    )}
                </Row>
            </div>
        </PostCommon>
    );
};

export default DoctorForm;